/**
 *
 * @param SKU 品運的SKU
 * @description
 * 品運的SET包裝規則:SET<qty>-<sku>
 * 例如: "SET20-4713025601584" => qty = 20, sku = 4713025601584
 * @returns [qty, sku] | []
 */

const tryallPackageSetSkuHandle = (SKU: string): [number, string] => {
  if (!SKU.startsWith("SET")) throw new Error("SKU 非 SET 開頭");

  const regex = /^SET(\d+)-(.+)/;
  const result = SKU.match(regex);
  if (!result) throw new Error("SKU 格式非包裝規則");

  // 如果符合規則，返回 qty 和 sku
  const qty = parseInt(result[1], 10);
  const sku = result[2];

  return [qty, sku];
};

export default tryallPackageSetSkuHandle;
